import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSuperAdminAuth } from '../../contexts/SuperAdminAuthContext';
import { getLoginUrl } from '../../utils/appDetection';

const SuperAdminProtectedRoute = ({ children, permission = null }) => {
  const { isAuthenticated, isLoading, checkPermission } = useSuperAdminAuth();
  const location = useLocation();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <div className="protected-route-loading">
        <div className="loading-container">
          <div className="loading-spinner">
            <i className="fas fa-spinner fa-spin"></i>
          </div>
          <p>Verifying authentication...</p>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return (
      <Navigate
        to={getLoginUrl('super-admin')}
        state={{ from: location }}
        replace
      />
    );
  }

  // Check specific permission if required
  if (permission && !checkPermission(permission)) {
    return (
      <div className="permission-denied">
        <div className="error-container">
          <div className="error-icon">
            <i className="fas fa-shield-alt"></i>
          </div>
          <h2>Access Denied</h2>
          <p>You don't have permission to access this resource.</p>
          <button 
            onClick={() => window.history.back()}
            className="btn-secondary"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  // Render the protected content
  return children;
};

export default SuperAdminProtectedRoute;